var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3214 0H10.6786V7.27411L7.95364 0.529669L6.43041 1.1451L9.22593 8.06425L3.94911 2.78743L2.78744 3.94911L7.84504 9.0067L1.29077 6.14308L0.633028 7.64852L7.56821 10.6786H0V12.3214H7.5682L0.63303 15.3515L1.29077 16.8569L7.84502 13.9933L2.78744 19.0509L3.94911 20.2125L9.22593 14.9357L6.43041 21.8549L7.95364 22.4703L10.6786 15.7259V23H12.3214V15.7259L15.0464 22.4703L16.5695 21.8549L13.7741 14.9357L19.0509 20.2125L20.2125 19.0509L15.1549 13.9933L21.7092 16.8569L22.3669 15.3515L15.4319 12.3214H23V10.6786H15.4317L22.3669 7.64852L21.7092 6.14308L15.1549 9.0067L20.2125 3.9491L19.0509 2.78743L13.7741 8.06424L16.5695 1.1451L15.0464 0.529669L12.3214 7.27411V0Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5c274732dd58868da90b1aa05cfa46eb.svg";
export { ForwardRef as ReactComponent };